module.exports = __webpack_public_path__ + "static/media/logo-closed-captioning.5a1ebda9.svg";